import {
    COUNSELLINGS_HOME_FETCH_FAILURE,
    COUNSELLINGS_HOME_FETCH_REQUEST,
    COUNSELLINGS_HOME_FETCH_SUCCESS,
    CounsellingsHomeFetchFailureAction,
    CounsellingsHomeFetchRequestAction,
    CounsellingsHomeFetchSuccessAction,
} from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHome.actions';
import { FORUM_READ_FEED_TRIGGER, ForumReadFeedTriggerAction } from 'mk2/apps/forum/actions';
import infiniteList, {
    initialState as initialInfiniteListState,
    State as InfiniteListState,
} from 'mk2/reducers/infiniteList';
import { Reducer } from 'redux';

export interface TopicStats {
    [topicId: number]: number;
}

export interface CounsellingsHomePageState extends InfiniteListState {
    topicIds: number[];
    counsellingIds: number[];
    followingTopicIds: number[];
    topicStats: TopicStats;
    lastVisitCounts: TopicStats;
}

export const initialCounsellingsHomePageState: CounsellingsHomePageState = {
    ...initialInfiniteListState,
    followingTopicIds: [],
    topicIds: [],
    counsellingIds: [],
    topicStats: {},
    lastVisitCounts: {},
};

const counsellingsHomePostsReducer = infiniteList<CounsellingsHomeFetchRequestAction, CounsellingsHomeFetchSuccessAction, CounsellingsHomeFetchFailureAction>(
    'COUNSELLINGS_HOME_FETCH',
    (a) => a.response.result.posts,
);

type CounsellingsHomePageReducerActions =
    CounsellingsHomeFetchRequestAction
    | CounsellingsHomeFetchSuccessAction
    | CounsellingsHomeFetchFailureAction
    | ForumReadFeedTriggerAction;

const counsellingsHomePageReducer: Reducer<CounsellingsHomePageState> =
    (state = initialCounsellingsHomePageState, action: CounsellingsHomePageReducerActions) => {
    switch (action.type) {
        case COUNSELLINGS_HOME_FETCH_REQUEST:
        case COUNSELLINGS_HOME_FETCH_FAILURE:
            return {
                ...state,
                ...counsellingsHomePostsReducer(state, action),
            };
        case COUNSELLINGS_HOME_FETCH_SUCCESS:
            return {
                ...state,
                ...counsellingsHomePostsReducer(state, action),
                topicIds: action.response.result.topics,
                counsellingIds: action.response.result.counsellings,
                followingTopicIds: action.response.result.followingTopics,
                topicStats: action.topicStats,
                lastVisitCounts: action.lastVisitCounts,
            };
        case FORUM_READ_FEED_TRIGGER:
            if (!action.feed.startsWith('subscribedCounsellings')) {
                return state;
            }

            const topicId = parseInt(action.feed.split('_')[1], 10);
            return {
                ...state,
                lastVisitCounts: {
                    ...state.lastVisitCounts,
                    [topicId]: 0,
                },
            };
        default:
            return state;
    }
};

export default counsellingsHomePageReducer;
